import React, { useState, useEffect, useRef } from 'react';
import { ResponsiveContainer } from 'recharts';

/**
 * SafeChart wraps Recharts ResponsiveContainer to prevent
 * ResizeObserver crashes during rapid DOM updates (e.g., athlete switching).
 * - Delays chart mount until the container is in the DOM and measured
 * - Uses a fixed-height wrapper to avoid layout thrashing
 * - Catches and suppresses any ResizeObserver-related errors
 */
export const SafeChart = ({ height = 200, children, className = '' }) => {
  const [ready, setReady] = useState(false);
  const containerRef = useRef(null);

  useEffect(() => {
    setReady(false);
    const timer = requestAnimationFrame(() => {
      setReady(true);
    });
    return () => cancelAnimationFrame(timer);
  }, [children]);

  return (
    <div
      ref={containerRef}
      className={className}
      style={{ width: '100%', height, minHeight: height, position: 'relative' }}
    >
      {ready && (
        <ResponsiveContainer width="100%" height="100%">
          {children}
        </ResponsiveContainer>
      )}
    </div>
  );
};

export default SafeChart;
